import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent } from "vue";
import { ref } from 'vue';
// vant 全局css变量
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const themeConfig = {};
    const transitionName = ref('scale');
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createBlock(_component_van_config_provider, {
        "theme-vars": themeConfig
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view, null, {
          default: _withCtx(({
            Component,
            route
          }) => [_createVNode(_Transition, {
            name: transitionName.value,
            mode: "out-in"
          }, {
            default: _withCtx(() => [!route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: route.name,
              class: "wrap"
            })) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["name"]), _createVNode(_Transition, {
            name: transitionName.value,
            mode: "out-in"
          }, {
            default: _withCtx(() => [route.meta.keepAlive ? (_openBlock(), _createBlock(_KeepAlive, {
              key: 0
            }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: route.path
            }))], 1024)) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["name"])]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});